import React, { Component } from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { configOperations } from '../../../redux/config';
import { mapOperations } from '../../../redux/map';

import { Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import FormGroup from '@material-ui/core/FormGroup';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RequiredFieldStatus from '../RequiredFieldStatus';

import '../DetailsIncidentPanel.css';

class MultiAgencyResponsePanel extends Component {
  constructor(props) {

    super(props);
    this.state = {
      open: true,
      highlightRequiredFields: false,
      primaryRequiredNullFields: [],
      requiredNullFields: [],
      derivingFields: [],
      secondaryRequiredNullFields: [],
      totalRequiredNullFields: null,
      requiredFields: props.requiredFields ? props.requiredFields : [],
      staticFields: props.staticFields ? props.staticFields : [],
      attributes: props.attributes,
      dependentFields: props.dependentFields ? props.dependentFields : []
    };
  }


  //TODO: Try to get rid of all componentWillReceiveProps
  componentWillReceiveProps(nextProps) {

   if (nextProps.panelCollapseState === true && this.state.totalRequiredNullFields === 0)
   {
     this.setState({
       open: false
     });
   }

   if (nextProps.panelCollapseState === true && this.state.totalRequiredNullFields > 0)
   {
     this.setState({
       open: true
     });
   }

    if (nextProps.expandAllPanels === true)
    {
      this.setState({
        open: true
      });
    }


   if(nextProps.requiredFields && this.props.requiredFields)
   {
     if (JSON.stringify({...nextProps.requiredFields}) !== JSON.stringify({...this.state.requiredFields}))
     {
       this.updateRequiredFields(nextProps.requiredFields);

       if(nextProps.attributes && this.props.attributes)
       {
           //this.updateRequiredNullFields(nextProps.attributes, nextProps.requiredFields);
       }
     }
   }

  }

updateRequiredFields = (updatedRequiredFields) =>
{
  this.setState({
    requiredFields: updatedRequiredFields
  });
}

  /*updateRequiredNullFields = (attributes, requiredFields) => {

    if (!requiredFields)
    {
      return;
    }
    if(!attributes) {
      console.warn('missing argument');
      return;
    }
    if(!attributes) {
      console.warn('missing argument');
      return;
    }
    const validationInfo = getValidationInfo(this.props.validationType, attributes, this.props.fieldInfos);
    //get null required fields
    //count in primary
    let primaryRequiredNullFields = [];
    this.props.primaryFields.forEach(fieldName => {
      const fieldVal = attributes[fieldName];
      const isRequired = requiredFields.includes(fieldName);
      if (isRequired && (fieldVal === undefined || fieldVal === null || validationInfo.invalidFields.includes(fieldName))) {
        primaryRequiredNullFields.push(fieldName)
      }
    });

    //count in secondary
    let secondaryRequiredNullFields = [];
    this.props.secondaryFields && this.props.secondaryFields.forEach(fieldName => {
      const fieldVal = attributes[fieldName];
      const isRequired = requiredFields.includes(fieldName);
      if (isRequired && (fieldVal === undefined || fieldVal === null || validationInfo.invalidFields.includes(fieldName))) {
        secondaryRequiredNullFields.push(fieldName)
      }
    });

    let requiredNullFields = [];
    this.props.fields.forEach(fieldName => {
      const fieldVal = attributes[fieldName];
      const isRequired = requiredFields.includes(fieldName);
      if (isRequired && (fieldVal === undefined || fieldVal === null || validationInfo.invalidFields.includes(fieldName))) {
        requiredNullFields.push(fieldName)
      }
    });

    //total count
    const totalRequiredNullFields = primaryRequiredNullFields.length + secondaryRequiredNullFields.length;
    this.setState({
      primaryRequiredNullFields,
      secondaryRequiredNullFields,
      totalRequiredNullFields,
      requiredNullFields
    })
  } */

  highlightRequiredFields = () =>
  {
    const open = this.state.open || (this.state.secondaryRequiredNullFields.length > 0);
    this.setState({
      open,
      highlightRequiredFields: true
    }, () => {
      window.setTimeout(() => {
        this.setState({highlightRequiredFields: false})
      }, 1000);
    });
  }

  accordionChange = (event) =>
  {
    this.setState({open: !this.state.open});
    this.props.resetPanelCollapseFlag();
  }

  updateAgencies = (code, isChecked)  =>
  {
      if (!isChecked)
      {
        this.props.removeInitialResponseAgency(code);
      }
      else
      {
        this.props.addInitialResponseAgency(code);
      }
  }

  render()
  {
    //const showRadios = (this.props.attributes.IsMultiAgencyInitialResponse !== null &&  this.props.attributes.IsMultiAgencyInitialResponse === 1);
    const showRadios = true;

    let requiredFieldStatusNode = '';
    if (this.state.totalRequiredNullFields > 0)
    {
      requiredFieldStatusNode = (
        <RequiredFieldStatus
          chipClicked={this.highlightRequiredFields}
          missingFields={this.state.totalRequiredNullFields} />
      )
    }

    let title = (
      <div className="incident-details-panel-header">
        <h4>{this.props.title}</h4>
        <span className="required-field-node-class">{requiredFieldStatusNode}</span>
      </div>
    )

    //TODO: Rewrite this checkbox code, it's hideous
    return (
      <Accordion className="incident-details-panel" expanded={this.state.open} onChange={this.accordionChange}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>{title}</AccordionSummary>
        <AccordionDetails>
        <div className="incident-details-panel-expander-top-align">

        <div className="detail-row" style={ (!showRadios) ? {display: 'none'} : {margin: 'auto'}}>
        <label className="detail-row-label" style={{minWidth:"200px"}}>Responding Agencies</label>
        <div className="detail-row-value">
        <FormGroup style={{marginLeft:"14px", marginTop:"0px"}}>
          <FormControlLabel
            control={<Checkbox name="BIA" color="primary" disabled={this.props.mode === "read"}
            onChange={(event) => {
              this.updateAgencies("BIA", (event.target.checked) ? 1 : 0);
            }
          }
            checked={this.props.attributes.InitialResponseAgencies && this.props.attributes.InitialResponseAgencies.includes('BIA')}/>} label="Bureau of Indian Affairs"/>

          <FormControlLabel
          control={<Checkbox name="BLM" color="primary" disabled={this.props.mode === "read"}
          onChange={(event) => {
            this.updateAgencies("BLM", (event.target.checked) ? 1 : 0);
          }}
          checked={this.props.attributes.InitialResponseAgencies && this.props.attributes.InitialResponseAgencies.includes('BLM')}/>} label="Bureau of Land Management"/>

          <FormControlLabel control={<Checkbox name="BOR" color="primary" disabled={this.props.mode === "read"}
          onChange={(event) => {

            this.updateAgencies("BOR", (event.target.checked) ? 1 : 0);
          }}
          checked={this.props.attributes.InitialResponseAgencies && this.props.attributes.InitialResponseAgencies.includes('BOR')}/>} label="Bureau of Reclamation"/>

          <FormControlLabel control={<Checkbox name="DOD" color="primary" disabled={this.props.mode === "read"}
          onChange={(event) => {

            this.updateAgencies("DOD", (event.target.checked) ? 1 : 0);
          }}
          checked={this.props.attributes.InitialResponseAgencies && this.props.attributes.InitialResponseAgencies.includes('DOD')}/>} label="Department of Defense"/>
          <FormControlLabel control={<Checkbox name="DOE" color="primary" disabled={this.props.mode === "read"}
          onChange={(event) => {

            this.updateAgencies("DOE", (event.target.checked) ? 1 : 0);
          }}
          checked={this.props.attributes.InitialResponseAgencies && this.props.attributes.InitialResponseAgencies.includes('DOE')}/>} label="Department of Energy"/>
          <FormControlLabel control={<Checkbox name="NPS" color="primary" disabled={this.props.mode === "read"}
          onChange={(event) => {
            this.updateAgencies("NPS", (event.target.checked) ? 1 : 0);
          }}
          checked={this.props.attributes.InitialResponseAgencies && this.props.attributes.InitialResponseAgencies.includes('NPS')}/>} label="National Park Service"/>
          <FormControlLabel control={<Checkbox name="USFS" color="primary" disabled={this.props.mode === "read"}
          onChange={(event) => {
            this.updateAgencies("USFS", (event.target.checked) ? 1 : 0);
          }}
          checked={this.props.attributes.InitialResponseAgencies && this.props.attributes.InitialResponseAgencies.includes('USFS')}/>} label="US Forest Service"/>
          <FormControlLabel control={<Checkbox name="USFWS" color="primary" disabled={this.props.mode === "read"}
          onChange={(event) => {
            this.updateAgencies("USFWS", (event.target.checked) ? 1 : 0);
          }}
          checked={this.props.attributes.InitialResponseAgencies && this.props.attributes.InitialResponseAgencies.includes('USFWS')}/>} label="US Fish and Wildlife Service"/>
          <FormControlLabel control={<Checkbox name="OthFed" color="primary" disabled={this.props.mode === "read"}
          onChange={(event) => {
            this.updateAgencies("OthFed", (event.target.checked) ? 1 : 0);
          }}
          checked={this.props.attributes.InitialResponseAgencies && this.props.attributes.InitialResponseAgencies.includes('OthFed')}/>} label="Other Federal"/>

          <FormControlLabel control={
            <Checkbox name="Foreign" color="primary" disabled={this.props.mode === "read"}
          onChange={(event) => {
            this.updateAgencies("Foreign", (event.target.checked) ? 1 : 0);
          }}
          checked={this.props.attributes.InitialResponseAgencies && this.props.attributes.InitialResponseAgencies.includes('Foreign')}/>} label="Foreign Government"/>

          <FormControlLabel control={<Checkbox name="Tribal" color="primary" disabled={this.props.mode === "read"}
          onChange={(event) => {
            this.updateAgencies("Tribal", (event.target.checked) ? 1 : 0);
          }}
          checked={this.props.attributes.InitialResponseAgencies && this.props.attributes.InitialResponseAgencies.includes('Tribal')}/>} label="Tribal Government (non-trust lands)"/>

          <FormControlLabel control={<Checkbox name="City" color="primary" disabled={this.props.mode === "read"}
          onChange={(event) => {
            this.updateAgencies("City", (event.target.checked) ? 1 : 0);
          }}
          checked={this.props.attributes.InitialResponseAgencies && this.props.attributes.InitialResponseAgencies.includes('City')}/>} label="City or Equivalent Government"/>

          <FormControlLabel control={<Checkbox name="County" color="primary" disabled={this.props.mode === "read"}
          onChange={(event) => {
            this.updateAgencies("County", (event.target.checked) ? 1 : 0);
          }}
          checked={this.props.attributes.InitialResponseAgencies && this.props.attributes.InitialResponseAgencies.includes('County')}/>} label="County or Equivalent Government"/>

          <FormControlLabel control={<Checkbox name="State" color="primary" disabled={this.props.mode === "read"}
          onChange={(event) => {
            this.updateAgencies("State", (event.target.checked) ? 1 : 0);
          }}
          checked={this.props.attributes.InitialResponseAgencies && this.props.attributes.InitialResponseAgencies.includes('State')}/>} label="State or Equivalent Government"/>

          <FormControlLabel control={<Checkbox name="Private" color="primary" disabled={this.props.mode === "read"}
          onChange={(event) => {
            this.updateAgencies("Private", (event.target.checked) ? 1 : 0);
          }}
          checked={this.props.attributes.InitialResponseAgencies && this.props.attributes.InitialResponseAgencies.includes('Private')}/>} label="Individual or Private Corporation"/>

          <FormControlLabel control={<Checkbox name="ANCSA" color="primary" disabled={this.props.mode === "read"}
          onChange={(event) => {
            this.updateAgencies("ANCSA", (event.target.checked) ? 1 : 0);
          }}
          checked={this.props.attributes.InitialResponseAgencies && this.props.attributes.InitialResponseAgencies.includes('ANCSA')}/>} label="Alaska Native Claims Settlement Act"/>

        </FormGroup>

        </div>
      </div>


        </div>
      </AccordionDetails>
      </Accordion>
    );
  }
}

const mapStateToProps = state => ({
  appConfig: state.config,
  map: state.map
})

const mapDispatchToProps = function (dispatch) {
  return bindActionCreators({
    ...configOperations,
    ...mapOperations
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(MultiAgencyResponsePanel)
